const mapboxgl = require('mapbox-gl')

/*
 *  Stefan's Free Account Access Token
 *  50K free API calls per month
 */
mapboxgl.accessToken = 'pk.eyJ1Ijoic3RlZmFuMCIsImEiOiJjajF3cHp5NXMwMGVpMnBwbXp2NGs5ZXh4In0.J9F1S6MYRIl_7D3jsE27aA'

const width = 800
const height = 800

var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v9',
  zoom: 14,
  center: [-122.4320895, 37.7388748]
})

const target = document.getElementById('map')
var nav = new mapboxgl.NavigationControl()
map.addControl(nav, 'top-left')

const canvas = document.getElementById('canvas')
const ctx = canvas.getContext('2d')

function drawBorder () {
  ctx.strokeStyle = '#ff0000'
  ctx.lineWidth = 2
  ctx.moveTo(1, 1)
  ctx.lineTo(width, 1)
  ctx.lineTo(width, height)
  ctx.lineTo(1, height)
  ctx.lineTo(1, 1)
  ctx.stroke()
}
drawBorder()

// let crossHairsDisplayed = false
function clearCanvas () {
  ctx.clearRect(0, 0, width, height)
  // crossHairsDisplayed = false
  // drawBorder()
}

/**
 * Clear the canvas after a delay time past the last event
 * @function
 */
const debounceClearCanvas = (() => {
  const delay = 250
  let timerId
  return function () {
    window.clearTimeout(timerId)
    timerId = setTimeout(() => {
      clearCanvas()
    }, delay)
  }
})()

function drawCrossHairs (x, y) {
  clearCanvas()
  // crossHairsDisplayed = true
  const dx = 50
  const dy = 50
  ctx.strokeStyle = '#000000'
  ctx.lineWidth = 5
  ctx.beginPath()
  ctx.moveTo(x, y - dy)
  ctx.lineTo(x, y + dy)
  ctx.stroke()
  ctx.moveTo(x - dx, y)
  ctx.lineTo(x + dx, y)
  ctx.stroke()
}

target.addEventListener('wheel', function (evt) {
  // console.log(evt)
  drawCrossHairs(evt.offsetX, evt.offsetY)
  debounceClearCanvas()
})

function getMobileOS () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }
  if (/android/i.test(userAgent)) {
    return 'Android'
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }
  return 'unknown'
}
const isIos = getMobileOS() === 'iOS'
const isAndroid = getMobileOS() === 'Android'
const wrapper = document.getElementById('wrapper')

/**
 * Array of Pointer Events (Android)
 * @type {Array}
 */
var evCache = []
/**
 * Array of Touch Events (iOS)
 * @type {Array}
 */
var tpCache = []
/**
 * Last difference in distance between Pointer events.
 * If the current difference is greater, then it is a zoom out
 * If the current difference is less, then it is a zoom in
 * @type {number}
 */
var prevDiff = -1

function pointerdownHandler (ev) {
  // The pointerdown event signals the start of a touch interaction.
  // This event is cached to support 2-finger gestures
  if (isAndroid) evCache.push(ev)
  if (isIos) tpCache.push(ev)
  console.log('pointerDown', ev)
}

function pointermoveHandler (ev) {
  // This function implements a 2-pointer horizontal pinch/zoom gesture.
  //
  // This function sets the target element's border to "dashed" to visually
  // indicate the pointer's target received a move event.
  console.log('pointerMove', ev)
  ev.target.style.border = 'dashed'
  const offsetTop = wrapper.offsetTop
  const offsetLeft = wrapper.offsetLeft

  var point1 = -1
  var point2 = -1
  /*
   * The first event, targetTouches[0] is point1
   * The second event, targetTouches[1] is point2
   */
  if (isIos) {
    if (ev.targetTouches && ev.targetTouches.length > 1) {
      for (let i = 0; i < tpCache.length; i++) {
        const tp = tpCache[i]
        for (let j = 0; j < tp.targetTouches.length; j++) {
          if (tp.targetTouches[j].identifier === ev.targetTouches[0].identifier) point1 = j
          if (tp.targetTouches[j].identifier === ev.targetTouches[1].identifier) point2 = j
        }
      }
    }
    if (point1 >= 0 && point2 >= 0) {
      // let diff1 = 0
      // let diff2 = 0
      let dist = 0
      // Calculate the difference between the start and move coordinates
      if ((tpCache.length > 1) && (tpCache[1].touches.length > 1)) {
        const diff1 = Math.abs(tpCache[point1].touches[0].clientX - ev.targetTouches[0].clientX)
        const diff2 = Math.abs(tpCache[point2].touches[1].clientX - ev.targetTouches[1].clientX)
        dist = Math.sqrt(diff1 * diff1 + diff2 * diff2)
      }

      var PINCH_THRESHHOLD = 5
      if (dist > PINCH_THRESHHOLD) {
        // var tx = (tpCache[0].touches[0].clientX + tpCache[1].touches[1].clientX) / 2
        // var ty = (tpCache[0].touches[0].clientY + tpCache[1].touches[1].clientY) / 2
        var tx = (tpCache[1].touches[0].clientX + tpCache[1].touches[1].clientX) / 2
        var ty = (tpCache[1].touches[0].clientY + tpCache[1].touches[1].clientY) / 2
        tx -= offsetLeft
        ty -= offsetTop
        console.log('tx, ty:', tx, ty)
        // ev.target.style.background = "green";
        drawCrossHairs(tx, ty)
        debounceClearCanvas()
      }
    } else {
      // empty tpCache
      tpCache = []
    }
  } else if (isAndroid) {
    // Find this event in the cache and update its record with this event
    for (let i = 0; i < evCache.length; i++) {
      if (ev.pointerId === evCache[i].pointerId) {
        evCache[i] = ev
        break
      }
    }
    // If two pointers are down, check for pinch gestures
    if (evCache.length === 2) {
      // Calculate the distance between the two pointers
      var curDiff = Math.abs(evCache[0].clientX - evCache[1].clientX)
      // var x = (evCache[0].clientX + evCache[1].clientX) / 2
      // var y = (evCache[0].clientY + evCache[1].clientY) / 2
      var x = (evCache[0].offsetX + evCache[1].offsetX) / 2
      var y = (evCache[0].offsetY + evCache[1].offsetY) / 2

      if (prevDiff > 0) {
        if (curDiff > prevDiff) {
          // The distance between the two pointers has increased
          console.log('Pinch moving OUT -> Zoom in', ev)
          // ev.target.style.background = 'pink'
          drawCrossHairs(x, y)
          debounceClearCanvas()
        }
        if (curDiff < prevDiff) {
          // The distance between the two pointers has decreased
          console.log('Pinch moving IN -> Zoom out', ev)
          // ev.target.style.background = 'lightblue'
          drawCrossHairs(x, y)
          debounceClearCanvas()
        }
      }

      // Cache the distance for the next move event
      prevDiff = curDiff
    }
  }
}

function pointerupHandler (ev) {
  console.log('pointerUp', ev.type, ev)
  // Remove this pointer from the cache and reset the target's
  // background and border
  removeEvent(ev)
  ev.target.style.background = 'white'
  ev.target.style.border = '1px solid black'

  // If the number of pointers down is less than two then reset diff tracker
  if (isAndroid) {
    if (evCache.length < 2) {
      prevDiff = -1
    }
  }
}

/**
 * Remove this event from the target's cache
 *
 * @param {TouchEvent | PointerEvent} ev
 */
function removeEvent (ev) {
  // Remove this event from the target's cache
  if (isAndroid) {
    for (let i = 0; i < evCache.length; i++) {
      if (evCache[i].pointerId === ev.pointerId) {
        evCache.splice(i, 1)
        break
      }
    }
  } else if (isIos) {
    tpCache = []
    // for (let i = 0; i < tpCache.length; i++) {
    //   const tp = tpCache[i]
    //   for (let j = 0; j < tp.targetTouches.length; j++) {
    //     for (let k = 0; k < ev.targetTouches.length; k++) {
    //       if (tp.targetTouches[j].identifier === ev.targetTouches[k].identifier) {
    //         tpCache.splice(i, 1)
    //         return
    //       }
    //     }
    //   }
    // }
  }
}

/**
 * Add pointer or touch event handlers
 */
function initTouch () {
  if (isIos) {
    // iOS
    target.ontouchstart = pointerdownHandler
    target.ontouchmove = pointermoveHandler
    target.ontouchend = pointerupHandler
    target.ontouchcancel = pointerupHandler
  } else if (isAndroid) {
    target.onpointerdown = pointerdownHandler
    target.onpointermove = pointermoveHandler
    target.onpointerup = pointerupHandler
    target.onpointercancel = pointerupHandler
    target.onpointerout = pointerupHandler
    target.onpointerleave = pointerupHandler
  }
}

initTouch()
